RivalIQ.apps.Dashboard.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    const StackedBar = widgets.StackedBar = widgets.Chart.extend({
        chartType: RivalIQ.graph.StackedBar,
        template: '#widgetMetricStackedBarTemplate',
        ui: {
            metricLabel: '.metric-label'
        },

        serializeData: function () {
            const me = this;
            return {
                metricLabel: _.result(me.dashboardModel, 'getMetricLabel')
            };
        },

        getChartClassName: function (d, i, j) {
            const me = this;
            return widgets.Chart.TrailingChart.getChartClassName(me, i, j);
        },

        getAnnotations: function () {
            const me = this;

            const concept = me.collection.first();

            const interval = (me.getProp('interval') || me.getProp('defaultInterval'));
            const period = _.get(RivalIQ.utils.timePeriod.interval, [interval], RivalIQ.utils.timePeriod.interval.daily);

            if (period === RivalIQ.utils.timePeriod.interval.daily) {
                return [];
            } else {
                const annotationInformation = RivalIQ.str('incomplete_period', period);
                const annotations = _.map(concept?.getIncompleteBuckets(), function (idx) {
                    return {
                        x: idx,
                        icon: '\uf069',
                        information: annotationInformation
                    };
                });

                return annotations;
            }
        },

        getChartAttributes: function () {
            const me = this;

            const chartAttributes = widgets.Chart.prototype.getChartAttributes.apply(me, arguments);

            const showPlusMinusGraph = Boolean(me.getProp('showPlusMinusGraph'));

            const overrides = {
                yTicks: (showPlusMinusGraph ? 6 : undefined),
                showPlusMinusGraph: showPlusMinusGraph
            };

            const interval = (me.getProp('interval') || me.getProp('defaultInterval'));
            if (interval) {
                overrides.tickPosition = RivalIQ.enums.graph.position.MIDDLE;
            }

            return _.extend(chartAttributes, overrides);
        },

        reload: function () {
            const me = this;
            if (me.ui.metricLabel && me.ui.metricLabel.html) {
                const metricLabel = _.result(me.dashboardModel, 'getMetricLabel');
                me.ui.metricLabel.html(metricLabel);
            }

            widgets.Chart.prototype.reload.apply(me, arguments);
        },

        getTooltip: function () {
            const me = this;

            const getConcept = function () {
                let concept = me.model;
                if (!(concept instanceof RivalIQ.models.Metric)) {
                    concept = me.collection.first();
                }
                return concept;
            };

            return {
                title: function (data, index) {
                    return getConcept().getDomainName(index, {
                        withInterval: true
                    });
                },

                content: function (data, index, group) {
                    let total = 0;

                    const metrics = me.collection.map(function (metric, i) {
                        const value = data[i].value;
                        if (_.isFinite(value)) {
                            total += value;
                        }

                        return new RivalIQ.models.MetricDefinition(_.extend(metric.toJSON(), {
                            value: metric.format(value)
                        }));
                    });

                    // NOTE this feels like a hack, but what it does is use the
                    // next color when we are showing a plus/minus graph and
                    // only one metric is provided (e.g., the Metric Changes
                    // widget)
                    let colorIndex = group;
                    if (Boolean(me.getProp('showPlusMinusGraph')) && _.size(me.getProp('metrics')) < 2) {
                        const value = _.get(data, [0, 'value']);
                        if (value < 0) {
                            colorIndex = 1;
                        }
                    }

                    const concept = getConcept();
                    const metric = {
                        value: concept.format(total),
                        name: (concept.get('title') || concept.getName()),
                        colorIndex: colorIndex
                    };

                    if (me.model) {
                        _.defaults(metric, me.model.toJSON());
                    }

                    let metricsCollection = [];
                    if (_.size(metrics) > 1) {
                        metricsCollection = new RivalIQ.collections.MetricDefinitions(
                            // 04/22/2020 BC Ko https://github.com/RivalIQ/rivaliq-server/issues/25336
                            // reversed metrics before showing MetricSummaryTooltip
                            // match the props order in widget configuration
                            metrics.reverse()
                        );
                    }

                    return new App.widgets.MetricSummaryTooltip({
                        model: new RivalIQ.models.MetricDefinition(metric),
                        collection: metricsCollection
                    }).render().el.outerHTML;
                }
            };
        }
    });

    widgets.MetricStackedBarChartWidget = RivalIQ.apps.Dashboard.models.Widget.extend({
        view: StackedBar,

        getMetricLabel: function () {
            const me = this;
            let metricLabel;


            const interval = (me.getProp('interval') || me.getProp('defaultInterval'));
            const intervalStr = RivalIQ.enums.timePeriod.interval[interval] || RivalIQ.enums.timePeriod.interval.daily;
            const metricLabelName = _.result(me, ['metricLabelName']);
            if (metricLabelName) {
                return RivalIQ.str(metricLabelName, intervalStr);
            }

            switch (me.metricGroupType) {
                case 'likes':
                    metricLabel = RivalIQ.strings.facebook_insights_page_fan_metric_label;
                    break;
                case 'fb_reach':
                    metricLabel = RivalIQ.strings.facebook_insights_reach_widget_metric_label;
                    break;
                case 'reach':
                    metricLabel = RivalIQ.strings.linked_in_insights_reach_widget_metric_label;
                    break;
                case 'followers':
                    metricLabel = RivalIQ.strings.linked_in_insights_followers_metric_label;
                    break;
                case 'visitors':
                    metricLabel = RivalIQ.strings.linked_in_insights_visitors_widget_metric_label;
                    break;
                case 'profile_eng':
                    metricLabel = RivalIQ.strings.instagram_insights_profile_engagement_metric_label;
                    break;
                case 'insta_new_followers':
                    metricLabel = RivalIQ.strings.instagram_insights_follower_adds_metric_label;
                    break;
                case 'profile_views':
                    metricLabel = RivalIQ.strings.instagram_insights_profile_views_metric_label;
                    break;
                case 'reach-by-day':
                    metricLabel = RivalIQ.strings.instagram_insights_reach_by_day_metric_label;
                    break;
                case 'impressions-by-day':
                    metricLabel = RivalIQ.strings.instagram_insights_impressions_by_day_metric_label;
                    break;
                case 'linkedin_insights_profile_analytics_profile_views_by_day':
                    metricLabel = RivalIQ.strings.linked_in_insights_profile_views_by_day_metric_label;
                    break;
                case 'linkedin_insights_profile_analytics_unique_profile_views_by_day':
                    metricLabel = RivalIQ.strings.linked_in_insights_unique_profile_views_by_day_metric_label;
                    break;
                case 'linkedin_insights_profile_post_impressions_by_day':
                    metricLabel = RivalIQ.strings.linked_in_insights_post_impressions_by_day_metric_label;
                    break;
                case 'linkedin_insights_profile_post_reach_by_day':
                    metricLabel = RivalIQ.strings.linked_in_insights_post_reach_by_day_metric_label;
                    break;
                case 'linkedin_insights_profile_post_engagement_by_day':
                    metricLabel = RivalIQ.strings.linked_in_insights_post_engagement_by_day_metric_label;
                    break;
                case 'linkedin_insights_net_followers_by_day':
                    metricLabel = RivalIQ.strings.linked_in_insights_net_followers_by_day;
                    break;
                case 'facebook_insights_profile_consumptions_by_day':
                    metricLabel = RivalIQ.strings.facebook_insights_profile_consumptions_by_day_metric_label;
                    break;
                case 'facebook_insights_profile_page_views_by_day':
                    metricLabel = RivalIQ.strings.facebook_insights_profile_page_views_by_day_metric_label;
                    break;
                case 'facebook_insights_profile_page_cta_by_day':
                    metricLabel = RivalIQ.strings.facebook_insights_profile_page_cta_by_day_metric_label;
                    break;
                case 'facebook_insights_profile_page_consumptions_by_day':
                    metricLabel = RivalIQ.strings.facebook_insights_profile_page_consumptions_by_day_metric_label;
                    break;
                default:
                    if (me.metric instanceof RivalIQ.models.MetricDefinition) {
                        metricLabel = me.metric.attributes.name;
                        if (!metricLabel) {
                            metricLabel = RivalIQ.metric.names.metricName(me.metric.attributes, {
                                dimensions: ['timeAnalysisMode', 'day']
                            });
                        }
                    }
                    break;
            }

            return metricLabel;
        },

        processProps: function (props) {
            const me = this;

            _.defaults(props, {
                inline: false,
                legend: false
            });

            if (props.updateMetricsWithInterval) {
                const interval = RivalIQ.enums.timePeriod.interval[props.interval] || 'day';
                props.metrics[0] = RivalIQ.metric.timePeriod.setInterval(props.metrics[0], interval);

                delete me.metrics;
            }
            props = widgets.Chart.buildMetrics(me, props);

            return props;
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.METRIC_STACKED_BAR_CHART, widgets.MetricStackedBarChartWidget);

});
